import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9375 24C11.9386 24 7.96601 24 4 24C1.79086 24 4.05403e-07 22.2091 3.49982e-07 20C2.16183e-07 14.6667 1.72474e-07 9.33333 8.03423e-08 4C4.21801e-08 1.79086 1.79086 1.09105e-06 4 9.78196e-07C9.33333 7.05733e-07 14.6667 5.93166e-07 20 2.79037e-07C22.2091 1.48921e-07 24 1.79086 24 4C24 9.33333 24 14.6667 24 20C24 22.2091 22.2091 24 20 24C18.6537 24 17.3015 24 15.9375 24ZM7.7979 11.9531C7.7979 9.97493 7.7979 7.99672 7.7979 6.01462C6.82839 6.01462 5.90347 6.01462 4.98743 6.01462C4.98743 10.3794 4.98743 14.7129 4.98743 19.0504C9.12763 19.0504 13.2415 19.0504 17.3637 19.0504C17.3637 18.2008 17.3637 17.3814 17.3637 16.5231C14.1715 16.5231 11.0081 16.5231 7.7979 16.5231C7.7979 15.0052 7.7979 13.5261 7.7979 11.9531ZM15.3044 4.48025C15.2591 4.54372 15.2121 4.60604 15.1688 4.67081C14.3322 5.92139 14.7297 7.55141 16.0518 8.29315C17.2939 8.98993 18.9121 8.44879 19.5301 7.13006C20.0459 6.02927 19.6905 4.71735 18.6873 4.01936C17.6165 3.27428 16.329 3.43311 15.3044 4.48025Z"
      fill="#11181C"
    />
  </svg>
)
